<template>
  <div class="submitted-section invoice-section">
    <b-row>
      <b-col>
        <h3 class="title-slash headings">
          {{ $t('invoices.single.infoV2.invoiceInformation') }}
        </h3>
      </b-col>
      <b-col v-if="isIndian">
        <div class="d-flex justify-content-around float-md-right">
          <div class="help-text mr-4 text-uppercase">
            {{ $t('invoices.requestQuery.helpText') }}
          </div>
          <b-button
            variant="secondary"
            size="sm"
            @click.prevent="showRequestModal()"
            class="request-button p-2 mr-3 text-uppercase"
          >
            {{ $t('invoices.requestQuery.requestText') }}
          </b-button>
          <question-modal
            ref="question-modal"
            :key="questionKey"
            :invoice="invoice"
            :modal="modal"
            @request-success-modal="emitSuccessModal()"
          />
          <request-success-modal ref="requestSuccessModal" />
        </div>
      </b-col>
    </b-row>
    <div>
      <div class="section tb-row">
        <b-row>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.buyer') }}
            </div>
            <div class="subtitle">{{ invoice.importer }}</div>
          </b-col>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.reference') }}
            </div>
            <div class="subtitle">{{ invoice.reference }}</div>
          </b-col>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.invoiceDate') }}
            </div>
            <div class="subtitle">
              {{ (invoice.invoice_date || 'N/A') | moment('MMMM D, YYYY') }}
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.currency') }}
            </div>
            <div class="subtitle">{{ invoice.currsym }}</div>
          </b-col>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.grossValue') }}
            </div>
            <div class="subtitle">
              {{ invoice.info.gross_value | currency(invoice.currsym) }}
            </div>
          </b-col>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.advanceReceived') }}
            </div>
            <div class="subtitle">
              {{ invoice.info.advance_received | currency(invoice.currsym) }}
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.value') }}
            </div>
            <div class="subtitle">
              {{ invoice.value | currency(invoice.currsym) }}
            </div>
          </b-col>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.maxAmount') }}
            </div>
            <div class="subtitle">
              {{ maxAdvance | currency(invoice.currsym) }}
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <h3 class="title-slash headings">
      {{ $t('invoices.single.infoV2.shippingDetails') }}
    </h3>
    <div>
      <div class="section tb-row">
        <b-row>
          <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.shippingBillDate') }}
            </div>
            <div class="subtitle">
              {{
                (invoice.shipping_bill_date || 'N/A') | moment('MMMM D, YYYY')
              }}
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.shippingLine') }}
            </div>
            <div class="subtitle">{{ invoice.shipping_line }}</div>
          </b-col>
          <b-col v-if="!isIFProduct">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.consignee') }}
            </div>
            <div class="subtitle">{{ invoice.consignee || 'N/A' }}</div>
          </b-col>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.vesselName') }}
            </div>
            <div class="subtitle">{{ invoice.vessel_name || 'N/A' }}</div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.container') }}
            </div>
            <div class="subtitle">{{ invoice.container || 'N/A' }}</div>
          </b-col>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.blNo') }}
            </div>
            <div class="subtitle">{{ invoice.bl_no || 'N/A' }}</div>
          </b-col>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.blDate') }}
            </div>
            <div class="subtitle">
              {{ (invoice.bl_date || 'N/A') | moment('MMMM D, YYYY') }}
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col>
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.userDueDate') }}
            </div>
            <div class="subtitle">
              {{ (invoice.user_due_date || 'N/A') | moment('MMMM D, YYYY') }}
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <h3 class="title-slash headings">
      {{ $t('invoices.single.infoV2.fundingInformation') }}
    </h3>
    <div>
      <div class="section tb-row">
        <b-row>
          <b-col :lg="12">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.fundingType') }}
            </div>
            <div class="subtitle">{{ fundingType }}</div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row" v-if="invoice.client_bank_detail">
        <b-row>
          <b-col :lg="12">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.clientBankDetailId') }}
            </div>
            <div class="subtitle">{{ invoice.client_bank_detail.details }}</div>
          </b-col>
        </b-row>
      </div>
      <div class="section tb-row">
        <b-row>
          <b-col :lg="12">
            <div class="title pb-0 pb-md-1">
              {{ $t('invoices.add.form.customerNotes') }}
            </div>
            <div class="subtitle">
              {{ invoice.form_data.customer_notes || 'N.A' }}
            </div>
          </b-col>
        </b-row>
      </div>
      <template v-if="showCoverLetterSection">
        <h3 class="headings">
          {{ $t('coverLetter.title') }}
        </h3>
        <div class="section tb-row">
          <b-row>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.bankName') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.buyer_bank_name || 'N.A' }}
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="section tb-row">
          <b-row>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.bankAddress') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.buyer_bank_address || 'N.A' }}
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="section tb-row">
          <b-row>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.swift') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.swift_code || 'N.A' }}
              </div>
            </b-col>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.pinCode') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.post_code || 'N.A' }}
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="section tb-row">
          <b-row>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.contactName') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.contact_name || 'N.A' }}
              </div>
            </b-col>
            <b-col>
              <div class="title pb-0 pb-md-1">
                {{ $i18n.t('coverLetter.inputLabels.contactNumber') }}
              </div>
              <div class="subtitle">
                {{ cover_letter_instruction.contact_phone || 'N.A' }}
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import QuestionModal from '@/components/invoices/modals/QuestionModal'
import RequestSuccessModal from '@/components/invoices/modals/RequestSuccessModal'
export default {
  props: ['invoice'],
  data() {
    return {
      modal: false,
      questionKey: false,
      showCoverLetterSection: false,
      cover_letter_instruction: {}
    }
  },
  mounted() {
    this.showCoverLetterSection =
      this.invoice['product_bank?'] && this.$i18n.locale.includes('IN')
    if (
      this.showCoverLetterSection &&
      this.invoice.form_data.cover_letter_instruction
    ) {
      this.cover_letter_instruction =
        this.invoice.form_data.cover_letter_instruction
    }
  },
  methods: {
    showRequestModal() {
      this.modal = true
      this.$mpTrack('Raise request triggered')
      this.$refs['question-modal'].show()
    },
    emitSuccessModal() {
      this.questionKey = !this.questionKey
      this.modal = false
      this.$refs.requestSuccessModal.show()
    }
  },
  computed: {
    isIFProduct() {
      if (this.invoice) {
        return this.invoice?.['packing_list?']
      }
      return false
    },
    maxAdvance() {
      return this.invoice.value * (this.invoice.plan.advance_rate / 100)
    },
    setOff() {
      const customerNotes =
        (this.invoice &&
          this.invoice.form_data &&
          this.invoice.form_data.customer_notes) ||
        ''
      return customerNotes.includes('Invoices to be adjusted')
    },
    fundingType() {
      return this.setOff
        ? this.$t('invoices.add.form.fundingTypes.adjustExisting')
        : this.$t('invoices.add.form.fundingTypes.fundNew')
    },
    isIndian() {
      return this.$store.state.account.country === 'India'
    }
  },
  components: {
    QuestionModal,
    RequestSuccessModal
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/variables';
.help-text {
  margin-top: 2rem;
  font-family: $lato;
  color: $dc-input-color;
  letter-spacing: 1.31px;
  font-size: 0.9rem;
}
.request-button {
  font-family: $montserrat;
  margin-top: 1.7rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 7px;
}
</style>
